<template>
  <v-form ref="newsEditForm" v-model="valid">
    <div class="back-btn" @click="$router.push({name: 'tag-landing-index'})">
      <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M36 27H23.83L29.42 21.41L28 20L20 28L28 36L29.41 34.59L23.83 29H36V27Z" fill="#8C959D"/>
      </svg>
    </div>
    <v-row>
      <v-col cols="12">
        <h1>{{this.id ? 'Редактирование посадочной страницы тега ' + tagLanding.tag.name + ' - ' + tagLanding.category.name : 'Создание посадочной страницы тега'}}</h1>
      </v-col>
      <v-col  cols="12" sm="5" md="4" xl="3">
        <v-tabs v-model="tabLang">
          <v-tab>RU</v-tab>
          <v-tab>UA</v-tab>
        </v-tabs>
        <v-tabs-items v-model="tabLang">
          <v-tab-item :eager="true">
            <v-row>
              <v-col>
                <v-text-field
                        v-model="tagLanding.title"
                        label="Заголовок"
                        :rules="[rules.required]"
                        required
                        outlined
                ></v-text-field>
                <editor api-key="8z95zxrw4xtjnn7a2unyi14ym91kzk8j6549luv0ow3cmn2i" v-model="tagLanding.description" :init="{}" :toolbar="toolbar" :plugins="plugins"/>
                <v-text-field
                    v-model="tagLanding.seo_title"
                    label="SEO Title"
                    :rules="[rules.required]"
                    required
                    outlined
                ></v-text-field>
                <v-textarea
                    v-model="tagLanding.seo_description"
                    label="SEO Description"
                    :rules="[rules.required]"
                    required
                    outlined
                ></v-textarea>
              </v-col>
            </v-row>
          </v-tab-item>
          <v-tab-item :eager="true">
            <v-row>
              <v-col>
                <v-text-field
                    v-model="tagLanding.title_ua"
                    label="Заголовок"
                    :rules="[rules.required]"
                    required
                    outlined
                ></v-text-field>
                <editor api-key="8z95zxrw4xtjnn7a2unyi14ym91kzk8j6549luv0ow3cmn2i" v-model="tagLanding.description_ua" :init="{}" :toolbar="toolbar" :plugins="plugins"/>
                <v-text-field
                    v-model="tagLanding.seo_title_ua"
                    label="SEO Title"
                    :rules="[rules.required]"
                    required
                    outlined
                ></v-text-field>
                <v-textarea
                    v-model="tagLanding.seo_description_ua"
                    label="SEO Description"
                    :rules="[rules.required]"
                    required
                    outlined
                ></v-textarea>
              </v-col>
            </v-row>
          </v-tab-item>
        </v-tabs-items>
        <v-text-field
            v-model="tagLanding.slug"
            label="URL"
            outlined
        ></v-text-field>
        <v-checkbox
            v-model="tagLanding.is_index"
            label="Индексировать"
        ></v-checkbox>
        <v-btn v-if="id" @click="update">Сохранить</v-btn>
        <v-btn v-else @click="create">Создать</v-btn>
      </v-col>
      <v-snackbar
              v-model="snackbar"
              :timeout="timeout"
              :color="snackbarColor"
              right
              top
      >
        {{ snackbarText }}
      </v-snackbar>
    </v-row>
  </v-form>
</template>

<script>
  // @ is an alias to /src
  import TagService from './../../api/TagService'
  import Editor from '@tinymce/tinymce-vue'

  export default {
    name: 'TagLandingEdit',
    props: {
        id: {
            default: null,
        }
    },
    components: {Editor},
    data: () => ({
      plugins: 'advlist autolink lists link image charmap print preview anchor searchreplace visualblocks code fullscreen insertdatetime media table paste code help wordcount',
      toolbar: 'undo redo | formatselect | bold italic backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat | code ',
      snackbar: false,
      timeout: 2000,
      snackbarText: '',
      snackbarColor: '',
      rules: {
        required: value => !!value || 'Нужно заполнить',
        requiredSelect: [(v) => !!v.id || 'Нужно заполнить'],
      },
      valid: true,
      tab: '',
      tabLang: '',
      tagLanding: {
        title: '',
        title_ua: '',
        description: '',
        description_ua: '',
        seo_title: '',
        seo_title_ua: '',
        seo_description: '',
        seo_description_ua: '',
        slug: '',
        is_index: false,
      },
      image: null,
      loading: true,
      loadingButton: false,
    }),
    mounted() {
        if(this.id) {
            TagService.getLanding(this.id)
                .then(response => {
                    this.tagLanding = response.data;

                    this.loading = false
                });
        }
    },
    methods: {
      validate() {
        this.$refs.newsEditForm.validate()
        if(this.tagLanding.title == '' && this.tagLanding.title_ua != ''){
          this.tabLang = 0;
        }
        if(this.tagLanding.title != '' && this.tagLanding.title_ua == ''){
          this.tabLang = 1;
        }

        if (this.tagLanding.description == '' && this.tagLanding.description_ua != '') {
          this.tabLang = 0;
        }
        if (this.tagLanding.description != '' && this.tagLanding.description_ua == '') {
          this.tabLang = 1;
        }

      },
      update(){
        this.validate()
        if(!this.valid){
          return false
        }

        this.loadingButton = true;
        let formData = this.getData();
        let id = this.tagLanding.id;
        TagService.updateLanding(id, formData).then(response => {
          this.snackbar = true;
          this.snackbarText = 'Страница успешно обновлена';
          this.snackbarColor = 'success';
        }).catch(error => {
          this.snackbar = true;
          this.snackbarText = 'Ошибка при обновлении страницы';
          this.snackbarColor = 'error';
        }).finally(() => {
          this.loadingButton = false
        })
      },
      getData() {
          let formData = new FormData();

          formData.append('id', this.id);
          formData.append('title', this.tagLanding.title);
          formData.append('title_ua', this.tagLanding.title_ua);
          formData.append('description', this.tagLanding.description);
          formData.append('description_ua', this.tagLanding.description_ua);
          formData.append('seo_title', this.tagLanding.seo_title);
          formData.append('seo_title_ua', this.tagLanding.seo_title_ua);
          formData.append('seo_description', this.tagLanding.seo_description);
          formData.append('seo_description_ua', this.tagLanding.seo_description_ua);
          formData.append('slug', this.tagLanding.slug);
          formData.append('is_index', this.tagLanding.is_index ? 1 : 0);


          return formData;
      }
    },
  }
</script>

<style scoped lang="scss">
  .image-placeholder{
    width: 100%;
    height: 100%;
    background-color: #F3F7FC;
    border-radius: 4px;
  }
  .news-images .v-image{
    max-height: 374px;
  }
  .mobile{
    width: 300px;
    height: 300px;
    margin-bottom: 24px;
  }
  .news{
    position: relative;
    &:before{
      content: "";
      padding-top: 100%;
      display: block;
    }

    .content{
      position: absolute;
      width: 100%;
      left: 0;
      top: 0;
      height: 100%;
      background-color: #F8FBFF;
      border-right-style: 3px;
      .img{
        height: 3.541vw;
        margin-top: .83vw;
      }
      .name{
        margin-top: .72vw;
        text-align: center;
        color: #8C959D;
      }
    }
  }
</style>
